import { mutatorAction } from 'satcheljs';
import getRegionalOptions from '../store/store';
export default mutatorAction('setRegionalConfiguration', function setRegionalConfiguration(supportedCultures, supportedShortDateFormats, supportedShortTimeFormats) {
    var regionalOptions = getRegionalOptions();
    regionalOptions.supportedCultures = supportedCultures;
    regionalOptions.supportedShortDateFormats = supportedShortDateFormats;
    regionalOptions.supportedShortTimeFormats = supportedShortTimeFormats;
});
//# sourceMappingURL=setRegionalConfiguration.js.map